<template>
    <div class='fxn-body'>
        <div class="fxn-login-header">
            <!-- <div class="fxn-pull-left">
                <img src="../assets/img/fxn-login.png" alt="">
            </div> -->
            <div class="fxn-pull-right">Welcome to Login</div>
        </div>
        <!-- Login Header End -->
        <div class="fxn-login">
            <div class="fxn-login-wrap">
                <div class="fxn-login-img">
                    <img src="../assets/img/fxn-login-bg.png" alt="">
                </div>
                <div class="fxn-login-form">
                    <h3>团贷网管理系统</h3>
                    <el-tabs v-model="activeName" @tab-click="handleClick">
                        <el-tab-pane label="账户密码登录" name="1">
                            <el-form @submit.native.prevent :model="LoginForm" :rules="LoginRules" ref="LoginForm">
                                <el-form-item prop="username">
                                    <el-input prefix-icon="iconfont iconperson" type="text" v-model.trim="LoginForm.username" autocomplete="off" placeholder="输入账号"></el-input>
                                </el-form-item>
                                <el-form-item prop="password">
                                    <el-input prefix-icon="iconfont iconunlock" type="password" v-model.trim="LoginForm.password" autocomplete="off" @keyup.enter.native="submitForm('LoginForm')" placeholder="输入密码"></el-input>
                                </el-form-item>
                            </el-form>
                            <el-button type="primary" class="fxn-button-block" native-type="submit" @click="submitForm('LoginForm')">登录</el-button>
                        </el-tab-pane>
                        <!-- 账户密码登录 End -->
                        <!-- <el-tab-pane label="手机号登录" name="second">

                        </el-tab-pane> -->
                        <!-- 手机号登录 End -->
                    </el-tabs>
                </div>
            </div>
        </div>
        <!-- Login Wrap End -->
        <div class="fxn-login-footer">
            <p>为了更好的网站体验，建议您使用谷歌、火狐、360极速模式等高版本的浏览器！</p>
            <span @click="toBeian">粤ICP备12043601号-1</span>
            <p>CopyRight &copy; 2019 深圳债卫士科技信息有限公司</p>
        </div>
        <!-- Login Footer End -->

        <!-- 实名认证 -->
        <el-dialog title="提示" :visible.sync="NoAuthentication" width="35%" :close-on-click-modal="true">
            <div class="fxn-text-center fxn-text-org fxn-font-size-18" v-if="idcard_status == 0">为加强合规作业管理、贯彻合法合规催收精神，首次注册登录用户者请进行实名认证，感谢配合！</div>
            <div class="fxn-text-center fxn-text-org fxn-font-size-18" v-if="idcard_status == 1">实名认证审核中，请稍等...</div>
            <div class="fxn-text-center fxn-text-org fxn-font-size-18" v-if="idcard_status == 3">您的实名认证信息审核不通过，请重新认证。</div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="NoAuthentication = false">取 消</el-button>
                <el-button v-show="idcard_status != 2" type="primary" @click="toAuthentication">去认证</el-button>
            </div>
        </el-dialog>
        <!-- 实名认证 End -->

        <!-- 合规宣导 -->
        <el-dialog title="合规宣导" :visible.sync="ComplianceWin" :close-on-click-modal="true" :before-close="ComplianceClose">
            <div class="fxn-complian-body">
                <div class="title">关于信息安全管理的合规宣导</div>
                <div class="wrap">
                    <div class="fxn-text-indent fxn-font-weight">随着互联网技术的飞速发展及公民个人信息安全保护的意识逐渐增强，我国法律体系对于个人信息安全的保护也愈发重视，相关法律规定逐渐完善，本着合规合法催收作业的品质要求，为加强催收作业过程中的信息安全管理，要求您严格遵守：</div>
                    <div>1、<span class="fxn-text-red">严禁非法获取、购买、出售或者提供客户的个人信息，</span>在开展业务时必须切实保护客户及相关当事人隐私，禁止非法泄露个人信息、采用非法手段或通过非法途径获取/买卖个人信息。</div>
                    <div>2、<span class="fxn-text-red">严禁向客户以外的第三方透露客户姓名、身份证号、电话、住址等个人信息，</span>不得向无关第三方发送短信、函件、邮件等，禁止通过张贴文书、散发资料、群发短信等任何方式将客户的信息提供给第三方。</div>
                    <div>3、<span class="fxn-text-red">严禁以任何理由私自留存客户信息，</span>不得从工作系统中复制客户信息存储在个人电脑、各类存储介质（如MP3\U盘、打印纸质留存等）中，或将信息通过任何方式进行传播。</div>
                    <div>4、<span class="fxn-text-red">您所使用电脑需设置独立锁屏密码，USB接口须禁用，您所使用的工号不得外借，</span>请您每周更换系统登录密码。</div>
                    <div class="fxn-text-indent">系统展示客户信息属于商业秘密，为保护相关信息所有人的合法权益，请您保证入职时已接受相关必要的保密教育与培训，并遵守相关法律法规。</div>
                    <div class="fxn-text-indent fxn-margin-t-20">附：法条规定</div>
                    <div class="fxn-text-indent fxn-font-weight">《最高人民法院、最高人民检察院关于办理侵犯公民个人信息刑事案件适用法律若干问题的解释》（2017.6.1）</div>
                    <div class="fxn-text-indent"><span class="fxn-font-weight">“公民个人信息”</span>：指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。</div>
                    <div class="fxn-text-indent">具体包括：<span class="fxn-font-weight fxn-text-decoration">姓名、身份证件号码、通信通讯联系方式、住址、账号密码、财产状况、行踪轨迹、通信内容、征信信息、财产信息、住宿信息、通信记录、健康生理信息、交易信息等等。</span></div>
                    <div class="fxn-text-indent fxn-font-weight">《中华人民共和国刑法》第二百五十三条之一【侵犯公民个人信息罪】</div>
                    <div class="fxn-text-indent">国家机关或者金融、电信、交通、教育、医疗等单位的<span class="fxn-font-weight">工作人员</span>，违反国家规定，将本单位在履行职责或者提供服务过程中获得的公民个人信息，<span class="fxn-font-weight">出售或者非法提供</span>给他人，情节严重的，<span class="fxn-font-weight fxn-text-red">处三年以下有期徒刑或者拘役，并处或者单处罚金。</span></div>
                    <div class="fxn-text-indent fxn-font-weight">窃取或者以其他方法非法获取上述信息，情节严重的，依照前款的规定处罚。</div>
                    <div class="fxn-text-indent">单位犯前两款罪的，对单位判处罚金，并对<span class="fxn-font-weight">其直接负责的主管人员</span>和其他直接责任人员，<span class="fxn-font-weight">依照各该款的规定处罚</span>。</div>
                    <div></div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="ComplianceClose()">取 消</el-button>
                <el-button v-show="idcard_status != 2" type="primary" @click="submitComplian">确认</el-button>
            </div>
        </el-dialog>
        <!-- 合规宣导 End -->

    </div>
</template>

<script>
    export default {
        data(){
            return{
                UserData: {},
                activeName: '1',
                idcard_status: '',
				NoAuthentication: false,			//实名认证
                //登录较验
                LoginForm: {
                    username: '',
                    password: '',
                },
                LoginRules: {
                    username: [
                        { required: true, message: '输入账号', trigger: 'blur' },
                    ],
					password: [
                        { required: true, message: '输入密码', trigger: 'blur' },
                        { min: 6, max: 18, message: '长度在 6 到 18 个字符', trigger: 'blur' }
                    ]
                },

                //合规宣导
                ComplianceWin: false,
            }
        },
        methods:{
            //用户名登录
            submitForm(formName){
                this.$refs[formName].validate((valid) => {
					if(valid) {
                        this.post('/osapi/Login/Loginact',{
							username: this.LoginForm.username,
							password: this.LoginForm.password
                        })
                        .then( res=>{
                            let { msg, code, data } = res.data;
							if (code !== 1) {
								this.$message({
									message: msg,
									type: 'error'
								});
							} else {
                                localStorage.setItem('token', JSON.stringify(res.data.data.token));
                                if(!res.data.data.today_login){
                                    this.UserData = res;
                                    this.ComplianceWin = true;
                                    return false
                                }else{
                                    this.getUserInfo(res)
                                }                                
                            }
                        })
                    }
                })
            },

            //重置增值服务状态
            async resetService() {
                return new Promise( (resolve,reject) => {
                    this.get('/osapi/login/getservice')
                    .then( res => {
                        resolve(res);
                    }).catch( (error) => {
                        reject(error)
                    })
                })
            },

            //用户信息/状态
            async getUserInfo(res){
                let is_white = res.data.data.memberInfo.is_white;
                if(is_white == 1){
                    this.$message({
                        message: '白名单限制登录!请联系管理员!',
                        type: 'error'
                    });
                }else{
                    localStorage.setItem('token', JSON.stringify(res.data.data.token));
                    let n = await this.resetService();        //重置增值服务状态 (获取到新的服务状态值才可往下执行)
                    console.log(n)
                    let user = res.data.data;
                    Object.keys(n.data.data).forEach( (key1) => {        
                        for ( let i in user.memberInfo) {
                            if (key1 == i) {
                                user.memberInfo[i] = n.data.data[key1]   //将获取到的服务状态值覆盖现有的
                                break
                            }
                        }
                    })
                    localStorage.setItem('user',JSON.stringify(user));
                    if(!user.memberInfo.psd_upd_time || user.memberInfo.psd_upd_time === '0'){
                        localStorage.setItem('pass_status','1')
                    }
                    this.$router.push({ path: '/' });
                    
                }
            },

            //去认证
			toAuthentication(){
				this.$router.push({ path: '/realName' });
			},

            //跳转备案
            toBeian(){
                window.open('https://beian.miit.gov.cn/');
            },

            //切换登录类型
            handleClick(){

            },

            //提交合规宣导
            submitComplian(){
                this.post('fapi/AVlogin/addlog')
                .then(res=>{
                    let { msg, code, data } = res.data;
                    if (code !== 1) {
                        this.$message({
                            message: msg,
                            type: 'error'
                        });
                    } else {
                        this.getUserInfo(this.UserData);
                    }
                })
            },

            //关闭合规宣导
            ComplianceClose(){
                this.$confirm('此操作将退出合规宣导无法登录, 是否继续?', '提示', {
                    confirmButtonText: '继续',
                    cancelButtonText: '否',
                    type: 'warning'
                }).then(() => {
                    this.ComplianceWin = true;
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '您已同意退出合规宣导'
                    });  
                    this.ComplianceWin = false;        
                });
            },
        },
        mounted(){
           
        },
        beforeCreate () {
            document.querySelector('body').setAttribute('style', 'background: #326fea;background: -webkit-linear-gradient(to right, #326fea, #2699f5); background: linear-gradient(to right, #326fea, #2699f5);')
        },
        beforeDestroy () {
            document.querySelector('body').removeAttribute('style','')
        }
    }
</script>

<style scoped>
    .fxn-complian-body{
        padding: 30px;
    }

    .fxn-complian-body .title{
        font-size: 36px;
        text-align: center;
        margin-bottom: 30px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Login.vue